import styled from "styled-components";

const PricingPlanQuestionsBox = ({ plan, inMobileView }) => {
  return (
    <Wrapper
      className="rounded-4 p-4 px-lg-5 text-left mx-auto mx-lg-0"
      style={{ marginTop: inMobileView ? "-2rem" : "0" }}
    >
      <h6 className="font-semibold font-25 text-light-black mb-4">
        Common Questions
      </h6>
      <div className="d-flex flex-column gap-4">
        {plan.questions.map((question) => (
          <div key={question.id}>
            <h6 className="font-weight-bold font-17 text-lighter-black">
              {question.question}
            </h6>
            <p className="font-15 text-light-black">{question.answer}</p>
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default PricingPlanQuestionsBox;

const Wrapper = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 485px;
  background-color: #f9f9f8;
  outline: 0.3px solid #7fb5fcff;
`;
